export const environment = {
    production: false,
    apiUrl: 'https://stagingapi.aslservices.com/',
    samlUrl: 'https://idmsac-uat.corp.apple.com/IDMSWebAuth/SAMLLogin?SAMLRequest='
  };
  